import { z } from 'zod';

export const refreshTokenRequestBodySchema = z.object({
  refresh_token: z.string().min(1),
  origin: z.url().describe('The origin of the request, used for the callback URL in the OIDC flow'),
});

export const tokenRequestBodySchema = z.object({
  code: z.string().min(1).optional(),
  code_verifier: z.string().min(1).optional(),
  refresh_token: z.string().min(1).optional(),
  origin: z.url().describe('The origin of the request, used fo the callback URL in the OIDC flow'),
}).or(refreshTokenRequestBodySchema);

export type TokenRequestBodyType = z.infer<typeof tokenRequestBodySchema>;
export type RefreshTokenRequestBodyType = z.infer<typeof refreshTokenRequestBodySchema>;

export const tokenResponseBodySchema = z.object({
  token: z.string().min(1),
  refreshToken: z.string().min(1).optional(),
});

export type TokenResponseType = z.infer<typeof tokenResponseBodySchema>;
